/**
 * Library package application and TrafficPulse AI context dispatch by tracker.
 * Native tracker AI is a separate vendor capability.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  matchTracker,
  trackerCan,
  type FlowOptimizerLibraryProvider,
  type TrackerId,
} from '@trafficpulse/shared';

export function libraryProviderOf(id: TrackerId): FlowOptimizerLibraryProvider | null {
  return matchTracker<FlowOptimizerLibraryProvider | null>(id, {
    voluum: () => 'voluum',
    binom: () => 'binom',
    'tres-commas': () => trackerCan('tres-commas', 'flowOptimizer') ? 'tres-commas' : null,
  });
}
